import createAPI from '../axios'
//出勤签到
const attendanceStatisticsAdultEducatrion = {
    attendanceStatistics: {
        findAttendanceStatisticsNew: config => createAPI('/AttendanceStatisticsAdultEducationController/findAttendanceStatisticsNew', 'post', config),
        findStudentByTeacherClass: config => createAPI('/AttendanceStatisticsAdultEducationController/findStudentByTeacherClass', 'post', config),
        saveMessage: config => createAPI('/AttendanceStatisticsAdultEducationController/saveMessage', 'post', config),
    }
}

export default attendanceStatisticsAdultEducatrion;



// WEBPACK FOOTER //
// ./src/api/modules/attendanceStatisticsAdultEducatrion.js